// Common consecration choices, resolved against the existing published Roman calendar.
// The selected year's actual observance supplies the date, including transfers.
export const CONSECRATION_FEASTS = [
  { key: "mary_mother_of_god", name: "Mary, Mother of God", usual: "01-01" },
  { key: "presentation_of_the_lord", name: "Presentation of the Lord", usual: "02-02" },
  { key: "our_lady_of_lourdes", name: "Our Lady of Lourdes", usual: "02-11" },
  { key: "annunciation_of_the_lord", name: "Annunciation of the Lord", usual: "03-25" },
  { key: "our_lady_of_fatima", name: "Our Lady of Fátima", usual: "05-13" },
  { key: "visitation_of_mary", name: "Visitation of Mary", usual: "05-31" },
  { key: "our_lady_of_mount_carmel", name: "Our Lady of Mount Carmel", usual: "07-16" },
  { key: "assumption_of_the_blessed_virgin_mary", name: "Assumption of Mary", usual: "08-15" },
  { key: "queenship_of_the_blessed_virgin_mary", name: "Queenship of Mary", usual: "08-22" },
  { key: "nativity_of_the_blessed_virgin_mary", name: "Nativity of Mary", usual: "09-08" },
  { key: "our_lady_of_sorrows", name: "Our Lady of Sorrows", usual: "09-15" },
  { key: "our_lady_of_the_rosary", name: "Our Lady of the Rosary", usual: "10-07" },
  { key: "presentation_of_the_blessed_virgin_mary", name: "Presentation of Mary", usual: "11-21" },
  { key: "immaculate_conception_of_the_blessed_virgin_mary", name: "Immaculate Conception", usual: "12-08" },
  { key: "our_lady_of_guadalupe", name: "Our Lady of Guadalupe", usual: "12-12" },
];